import { render, staticRenderFns } from "./TipoTicketEtapaEdit.vue?vue&type=template&id=350d262d&scoped=true"
import script from "./TipoTicketEtapaEdit.vue?vue&type=script&lang=js"
export * from "./TipoTicketEtapaEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350d262d",
  null
  
)

export default component.exports